"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _student = _interopRequireDefault(require("./student"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _propTypes.default.shape({
  id: _propTypes.default.number,
  image: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]),
  name: _propTypes.default.string,
  surname: _propTypes.default.string,
  city: _propTypes.default.string,
  state: _propTypes.default.string,
  classStanding: _propTypes.default.string,
  university: _propTypes.default.string,
  viewed: _propTypes.default.bool,
  tag: _propTypes.default.string,
  description: _propTypes.default.string,
  coverLetter: _propTypes.default.string,
  postulationDate: _propTypes.default.string,
  externalLinkSended: _propTypes.default.bool,
  resumeUrl: _propTypes.default.string,
  student: _student.default,
  whyOurCompanyReason: _propTypes.default.string,
  applyDate: _propTypes.default.string,
  contactTag: _propTypes.default.number,
  opportunityId: _propTypes.default.number,
  portfolioUrl: _propTypes.default.string,
  portfolioUrlShort: _propTypes.default.string,
  status: _propTypes.default.string,
  transcript: _propTypes.default.string,
  transcriptShort: _propTypes.default.string
});
exports.default = _default;